import * as Sentry from "@sentry/browser";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
  integrations: [
      Sentry.consoleLoggingIntegration({levels: ['log', 'warn', 'error']}),
  ],
  sendDefaultPii: true,
  enableLogs: true,
  environment: import.meta.env.VITE_ENVIRONMENT,
});

import './bootstrap';

import Alpine from 'alpinejs';

import '../css/app.css';

window.Alpine = Alpine;

Alpine.start();
